import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import apiService from '../../services/api';

export const fetchOrders = createAsyncThunk(
  'orders/fetchAll',
  async (params = {}, { rejectWithValue }) => {
    try {
      const res = await apiService.getOrders(params);
      // Handle both { data: [...] } and direct [...] response formats
      return Array.isArray(res) ? res : Array.isArray(res?.data) ? res.data : [];
    } catch (err) {
      return rejectWithValue(err.body?.error || err.message);
    }
  }
);

export const fetchOrderById = createAsyncThunk(
  'orders/fetchOne',
  async (id, { rejectWithValue }) => {
    try {
      const res = await apiService.getOrder(id);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.body?.error || err.message);
    }
  }
);

const ordersSlice = createSlice({
  name: 'orders',
  initialState: { list: [], selectedOrder: null, loading: false, error: null },
  reducers: {
    clearOrders: (state) => {
      state.list = [];
      state.selectedOrder = null;
      state.error = null;
    },
    setSelectedOrder: (state, action) => {
      state.selectedOrder = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchOrders.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchOrders.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload || [];
      })
      .addCase(fetchOrders.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchOrderById.fulfilled, (state, action) => {
        state.selectedOrder = action.payload;
      });
  },
});

export const { clearOrders, setSelectedOrder } = ordersSlice.actions;
export default ordersSlice.reducer;
